import { render, staticRenderFns } from "./ClassOfPositionSimulator.vue?vue&type=template&id=0b2f0e22&"
import script from "./ClassOfPositionSimulator.vue?vue&type=script&lang=js&"
export * from "./ClassOfPositionSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports